import Vue from 'vue'
import VueRouter from 'vue-router'
// import layout from '@/views/layout/index.vue'
import layout from '@/views/layout'// 简写
import login from '@/views/login/index.vue'
import search from '@/views/search/index.vue'
import searchList from '@/views/search/list.vue'
import goodsDetail from '@/views/goodsdetail/index.vue'
// import pay from '@/views/pay/index.vue'
import order from '@/views/order/index.vue'
import home from '@/views/layout/home.vue'
import category from '@/views/layout/category.vue'
import cart from '@/views/layout/cart.vue'
import user from '@/views/layout/user.vue'
import store from '@/store'

// 访问时才加载
const pay = () => import('@/views/pay/index.vue')

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/', redirect: '/home' },
    {
      path: '/layout',
      component: layout,
      children: [
        { path: '/home', component: home },
        { path: '/category', component: category },
        { path: '/cart', component: cart },
        { path: '/user', component: user }
      ]
    },
    { path: '/login', component: login },
    { path: '/search', component: search },
    { path: '/searchList', component: searchList },
    { path: '/goodsDetail/:id', component: goodsDetail },
    { path: '/pay', component: pay },
    { path: '/order', component: order },

    { path: '*', redirect: '/' }
  ]
})

// vue2 router3 vuex3
// vue3 router4 vuex4
// 全局前置守卫 ===> https://v3.router.vuejs.org/zh/guide/advanced/navigation-guards.html#%E5%85%A8%E5%B1%80%E5%89%8D%E7%BD%AE%E5%AE%88%E5%8D%AB
//      to:   到哪里去，到哪去的完整路由信息对象 (路径，参数)
//      from: 从哪里来，从哪来的完整路由信息对象 (路径，参数)
//      next(): 是否放行
//      (1) next()     直接放行，放行到to要去的路径
//      (2) next(路径)  进行拦截，拦截到next里面配置的路径

const authUrl = ['/pay', '/order']
router.beforeEach((to, from, next) => {
  // 无需认证
  if (!authUrl.includes(to.path)) {
    next()
    return
  }

  // 需要认证
  // const token = store.state.user.userInfo.token
  const token = store.getters.token
  if (token) {
    next()
  } else {
    next('/login')
  }
})

export default router
